/*
 *
 * sessionAPI.js
 *
 */

import Axios from "axios";

const sessionAPI = {
    login: async data => await Axios.post(`${window.API_URL}/auth/login.php`, {
        userName: data.userName,
        password: data.password
    }),
    sendPasswordReset: async data => await Axios.post(`${window.API_URL}/auth/resetPassword.php`, {
        userName: data.userName
    }),
    resetPassword: async data => await Axios.post(`${window.API_URL}/auth/resetPassword.php`, {
        password: data.password,
        token: data.token
    })
};

export default sessionAPI;